import type { UseMutationOptions } from 'react-query';
import { useMutation } from '@frontend/react-query-helpers';
import {
  attachPaymentMethod,
  type AttachPaymentMethodProps,
  type AttachPaymentMethodResponse,
} from '../requests/attach-payment-method';
import { paymentMethodMutationKeys } from './keys';

export const useAttachPaymentMethod = (
  options?: UseMutationOptions<AttachPaymentMethodResponse, unknown, AttachPaymentMethodProps>
) => {
  return useMutation({
    mutationKey: paymentMethodMutationKeys.attachPaymentMethod,
    mutationFn: (request) => attachPaymentMethod(request),
    ...options,
  });
};
